import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { OemConstants } from '../../../../app/core/routing/services/oem/constants/oem.constants';
import { OemService } from '../../../../app/core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { AttractorLoopVideo, ModelSKU } from '../interface/oem-portal-interface.i';

import { OemStoreService } from '../store/oem.store';
import { Enumvalues } from '../../../../app/core/routing/services/oem/constants/oem.constants'
import { first } from 'rxjs/internal/operators/first';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { Utils } from '../../../common/utils/utils';

@Component({
  selector: 'iposcen-attractor-loop-oem',
  templateUrl: './attractor-loop.component.html',
  styleUrls: ['./attractor-loop.component.scss']
})
export class AttractorLoopOemComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @Output() isModelSkuPresent = new EventEmitter();
  @Output() readonly showAuthorTabs = new EventEmitter();
  @Output() readonly editOnChange = new EventEmitter();
  isCreateNewAttrEnable = false;
  @Output() readonly attractorLoopId = new EventEmitter();
  @Output() readonly attractorViewOn = new EventEmitter();
  modelSkuList = [];
  @Output() attractorLoopEnabled = new EventEmitter();
  attractorLoop = []; //Populate this variable with modelsku's info.
  searchData: string;
  hasData: boolean;
  showFrom: number;
  showTo: number;
  paginationCount: number;
  page: number;
  tableSize: number;
  isAscendingSort = false;
  sortQueue = {};
  searchQueue = {};
  selectFilterQueue = {};
  filterString: string;
  searchClose: boolean;
  loadFlag: string;
  searchTag: string;
  systemID: string;
  maxSize = 5;
  displayModelName = [];
  globalSortValue: string;
  globalSortBy: string;
  searchPlaceholder: string = OemConstants.SYSTEMID_NAME_PLACEHOLDER;
  newAttractLoopButton: string = OemConstants.NEW_ATTRACTOR_LOOP;
  name = GlobalConstants.NAME;
  systemId = OemConstants.SYSTEM_ID;
  valueForSearchinUsers: string;
  modelSKUNAME = [];
  ellipsesCount = 12;
  updateModelSku: ModelSKU;
  noDataOnSearch: boolean;
  displayName: any[];
  displayEnglishName: any[];
  skuIdToEdit: string;
  editAlt = OemConstants.editAlt;
  searchAlt = OemConstants.searchAlt;
  closeAlt = OemConstants.closeAlt;
  editTooltip = OemConstants.EDIT_TEXT;
  deleteTooltip = GlobalConstants.DELETE;
  attractLoopToDelete: string;
  attractLoopToDeleteName: string;
  isSubmit: boolean = false;
  returnedTooltipDesc = OemConstants.ATTRACT_LOOP_RETURNED_DESC;
  approvedTooltipDesc = OemConstants.ATTRACT_LOOP_APPROVED_DESC;
  submittedTooltipDesc = OemConstants.ATTRACT_LOOP_SUBMITTED_DESC;
  obj = Object;
  selectList = new Map();
  @Output('sendDataOemPortal') sendData = new EventEmitter();
  @Output('isEditON') edit = new EventEmitter();
  colSortKey: string="";

  private ngUnsubscribe = new Subject();

  constructor(private router: Router, private oemStore: OemStoreService, private oemservice: OemService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.hasData = true;
    this.page = 1;
    this.tableSize = 10;
    this.searchClose = false;
    this.loadFlag = OemConstants.LOAD_FLAG;
    this.globalSortBy = OemConstants.UPDATED_TIME;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.noDataOnSearch = false;
    this.valueForSearchinUsers = GlobalConstants.NAME;
    this.attractorLoopEnabled.emit(true);
    this.getFilterSearchData();
  }
  onSelectChange(value) {
    if (value === Enumvalues.VALUE_1) {
      this.searchTag = OemConstants.ATTRACT_LOOPNAME_SEARCHTAG;
      this.valueForSearchinUsers = GlobalConstants.NAME;
    } else if (value === Enumvalues.VALUE_2) {
      this.searchTag = OemConstants.SYSTEM_ID_SEARCHTAG;
      this.valueForSearchinUsers = OemConstants.systemId;
    }
  }
  getAllAttractorLoop(filterString?: string) {
    this.oemservice.getAllAttractorLoop(this.globalSortBy, this.globalSortValue, filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllAttractorLoop => {
        getAllAttractorLoop.attractLoops.map(data => {
          let temp = Object.keys(data.systemIDMap);
          temp.forEach(k => {
            this.selectList.set(data.systemIDMap[k], k);
          })
           // Parse locations string to array when receiving data
           if (data.locations) {
            try {
              data.parsedLocations = JSON.parse(data.locations);
            } catch {
              data.parsedLocations = [];
            }
          }
        })
        this.attractorLoop = getAllAttractorLoop.attractLoops as AttractorLoopVideo[];
        this.attractorLoop.forEach(element => {
          // converting date format:
          if (element && element.configurations) {
            element.configurations = JSON.parse(element.configurations);
            if (element.configurations?.publishTime && !element.configurations.isPublishDateNow) {
                //changing it to old format
                element.configurations.publishTime = Utils.ChangetoOldFormat(element.configurations.publishTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime !== GlobalConstants.NEVER) {
              //changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element.configurations.expireTime);
            }
            if (element.configurations.expireTime && element.configurations.expireTime === GlobalConstants.NEVER) {              
              element.configurations.expireTime = GlobalConstants.NEVER;
            }
            element.configurations = JSON.stringify(element.configurations);
          }
        });

        if (this.attractorLoop.length) {
          this.hasData = true;
          this.showFrom = ((this.page - 1) * this.tableSize) + 1;
          this.isModelSkuPresent.emit('true')
        } else {
          this.hasData = false;
          this.showFrom = 0;
          this.showTo = 0;
          this.isModelSkuPresent.emit('false');
        }
        if (this.attractorLoop.length < 10) {
          this.showTo = this.attractorLoop.length;
        } else {
          this.showTo = this.page * this.tableSize;
        }
        //Fix for IIT2-10086
        if (this.colSortKey === OemConstants.ATTRACT_LOOPNAME) {
          let sortOrderAsc = this.isAscendingSort;
          this.attractorLoop.sort(function (a, b) {
            if (sortOrderAsc) {
              return a.attractLoopName.localeCompare(b.attractLoopName, undefined, { numeric: true, sensitivity: 'base' });
            } else {
              return b.attractLoopName.localeCompare(a.attractLoopName, undefined, { numeric: true, sensitivity: 'base' });
            }
          })
        }
      });
  }

  checkArray(data) {

    try {
      let temp = JSON.parse(data);
      if (typeof temp === 'number') {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  checkIfList(data) {
    return typeof data !== 'object';
  }



  // Call the search api here
  searchDataOnClick(data) {
    this.searchClose = true;
    if (this.loadFlag === OemConstants.LOAD_FLAG && !this.searchTag) {
      this.searchTag = OemConstants.ATTRACT_LOOPNAME_SEARCHTAG;
      this.loadFlag = OemConstants.UNLOAD_FLAG;
    }
    if (data && this.searchTag) {
      this.searchQueue[this.searchTag] = data;
      this.getSearchData(data);
    } else {
      this.getAllAttractorLoop();
      this.page = 1;
    }

  }

  getSearchData(data) {
    this.oemservice.searchWithData(this.globalSortBy, this.globalSortValue, data, this.searchTag)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
        this.attractorLoop = result.attractLoops as AttractorLoopVideo[];
        if (this.attractorLoop.length) {
          this.hasData = true;
          this.noDataOnSearch = false;
          this.showFrom = ((this.page - 1) * this.tableSize) + 1;
          this.isModelSkuPresent.emit('true')
        } else {
          this.noDataOnSearch = true;
          this.showFrom = 0;
          this.showTo = 0;
          this.isModelSkuPresent.emit('false');
        }
        if (this.attractorLoop.length < 10) {
          this.showTo = this.attractorLoop.length;
        } else {
          this.showTo = this.page * this.tableSize;
        }
        this.attractorLoop.forEach((v,i)=>{
            v.parsedLocations = JSON.parse(v?.locations);          
        })
      }) 
  }
  searchDataOnEnter(systemID) {
    this.animateThis.nativeElement.blur();
    this.searchDataOnClick(systemID);

  }

  clearSearchDirect() {
    this.searchClose = false;
    this.noDataOnSearch = false;
    this.searchData = '';
    this.searchQueue = {};
    this.getFilterSearchData();
    this.showFrom = this.page = 1;
    this.showTo = Math.min(this.page * this.tableSize, this.attractorLoop.length);
  }
  clearSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.clearSearchDirect();
    }
  }

  sort(sortKey: string) {
    this.colSortKey = sortKey;
    switch (sortKey) {
      case (OemConstants.ATTRACT_LOOPNAME):
        this.sortingTableWithAscandDesc(OemConstants.ATTRACT_LOOPNAME);
        break;
      case (OemConstants.DETECTION_STATUS):
        this.sortingTableWithAscandDesc(OemConstants.DETECTION_STATUS);
        break;
      case (OemConstants.UPDATED_TIME):
        this.sortingTableWithAscandDesc(OemConstants.UPDATED_TIME);
        break;
      case (OemConstants.UPDATED_BYNAME):
        this.sortingTableWithAscandDesc(OemConstants.UPDATED_BYNAME);
        break;
      default: {
      }
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    let sortOrder = "";
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = this.isAscendingSort ? OemConstants.ASCENDING_ORDER : OemConstants.DESCENDING_ORDER;

    this.sortQueue[OemConstants.SORTBY] = tempval;
    this.sortQueue[OemConstants.SORTTYPE] = sortOrder;
    this.getFilterSearchData();
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.selectFilterQueue || this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllAttractorLoop(this.filterString);
    } else {
      this.getAllAttractorLoop();
    }
  }



  checkCase(data) {
    if (data === OemConstants.APPROVED_STATUS) {
      return data.replace(data, OemConstants.APPROVED);
    } else if (data === OemConstants.SUBMITTED_STATUS) {
      return data.replace(data, OemConstants.SUBMITTED);
    } else if (data === OemConstants.RETURNED_STATUS) {
      return data.replace(data, OemConstants.RETURNED);
    } else if (data === OemConstants.SAVED_STATUS) {
      return data.replace(data, OemConstants.SAVED);
    }
  }

  onTableDataChange(event) {
    this.page = event;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize, this.attractorLoop.length);
  }
  editSKU(id: string) {
    this.oemStore.oemStoreData = undefined;
    this.router.navigate([RouterConstants.EDIT_SKU, id]);
  }

  openView(data) {
    this.sendData.emit(this.selectList);
    this.attractorViewOn.emit(true);
    this.attractorLoopId.emit(data);
    this.editOnChange.emit(false);
  }

  openDeleteModal(attractLoopId: string, attractLoopName: string) {
    this.attractLoopToDelete = this.attractorLoop.find(ele => ele.attractLoopId === attractLoopId).attractLoopId;
    this.attractLoopToDeleteName = this.attractorLoop.find(ele => ele.attractLoopName === attractLoopName).attractLoopName;
    this.openModal(this.deleteModal);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  deleteAttractLoop(attractLoopId: string) {
    // Delete API Intergration pending

    this.oemservice.deleteAttractLoop(attractLoopId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        if (deleteResponse.responseContext.success) {
          this.closeModal(this.deleteModal);
          setTimeout(_ => { this.getAllAttractorLoop(this.filterString); }, 2000);
        }
      },
        error => {
          this.closeModal(this.deleteModal);
        })
  }

  submit(attractLoopId) {
    this.isSubmit = true;
    const submitAction = {
      action: OemConstants.SUBMIT,
    }

    this.oemservice.submitAttractLoop(JSON.stringify(submitAction), attractLoopId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
      })

  }

  onCloseSubmitSuccessPopup() {
    this.isSubmit = false;
    this.getAllAttractorLoop();
    location.reload();
  }
  sendDataForCreateAttract(editEnable?) {
    this.sendData.emit(this.selectList);
    if (editEnable) {
      try {
        const editConfig = JSON.parse(editEnable.configurations);
        const currentAttractId = editEnable.attractLoopId;
        if (editConfig.groupAttractLoopId) {
          // Filter all attract loops with the same groupId
          const groupedAttracts = this.attractorLoop.filter(attract => {
            try {
              const config = attract?.configurations? JSON.parse(attract?.configurations):'';
              return config.groupAttractLoopId ===( editConfig.groupAttractLoopId  || '');
            } catch (error) {
              return false;
            }
          })
          // Sort by sequence, handling missing sequences
          const sortedAttracts = groupedAttracts.sort((a, b) => {
            try {
              const configA = JSON.parse(a.configurations);
              const configB = JSON.parse(b.configurations);

              // Handle cases where sequence might be undefined or null
              const sequenceA = typeof configA.sequence === 'number' ? configA.sequence : Infinity;
              const sequenceB = typeof configB.sequence === 'number' ? configB.sequence : Infinity;

              return sequenceA - sequenceB;
            } catch (error) {
              return 0;
            }
          })
          const selectedIndex = sortedAttracts.findIndex(attract =>
            attract.attractLoopId === currentAttractId
          );
          const attractsWithIndex = sortedAttracts.map(attract => ({
            ...attract,
            selectedIndexNum: selectedIndex
          }));
          this.edit.emit(attractsWithIndex);
        } else {
          this.edit.emit(editEnable);
        }
      } catch (error) {
        this.edit.emit(editEnable);
      }

    } else {
      this.edit.emit(false);
    }
  }
}
